import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import domConstruct from 'dojo/dom-construct';

import template from './TimeSlotPicker.html?raw';
import TimeSlotGroup from './TimeSlotGroup';
import _MandatoryMixin from '../_MandatoryMixin/_MandatoryMixin';
// NOTE (JS2TS): dropped dead deps dojo/dom-attr, dojo/dom-class, dojo/dom-style, dojo/on, dojo/query (imported but unused).

class TimeSlotPicker extends compose(_WidgetBaseSP, _MandatoryMixin) {
    [key: string]: any;
    templateString: any = template;

    _groups: any = [];
    roomGroupCount = 0;
    mandatoryNodePosition = "before";

    constructor(args: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, args);
        this._groups = [];
    }

    _checkValidity() {
        if (this.mandatory == false) {
            this.valid = true;
            return;
        }

        var selectedData = this.get("selection");
        if (!selectedData) {
            this.valid = false;
        }
        else {
            this.valid = selectedData.selectedSlots.length > 0;
        }

        this._showValidState();
        return this.valid;
    }

    _showValidState() {
        // override
        this._showMandatoryNotification(!this.valid);
    }

    _setReadOnlyAttr(value: any) {
        for (let i = 0; i < this._groups.length; i++) {
            let group = this._groups[i];
            group.set("readOnly", value);
        }

        this.disableNode(this.domNode, value);
    }

    _getSelectionAttr() {
        var selectedSlots = [];
        var selectedService = null;

        for (var i = 0; i < this._groups.length; i++) {
            var group = this._groups[i];

            var groupSelection = group.get("selection");
            if (groupSelection.length > 0) {
                selectedSlots = selectedSlots.concat(groupSelection);
                selectedService = group.service;
                break;
            }
        }

        return { service: selectedService, selectedSlots: selectedSlots };
    }

    _onSlotSelect(slotWidget: any, groupWidget: any) {
        for (var i = 0; i < this._groups.length; i++) {
            var group = this._groups[i];

            if (group != groupWidget) {
                group.unselectAll(); // immer nur eine gruppe des Pickers darf aktiv sein
            }
        }

        var selection = this.get("selection");

        this.emit("selected", selection);
        this.emit("change", selection);

        this._checkValidity();
    }

    setupGroupMapping(groupWidget: any) {
        // übersteuern...

        //groupWidget.title = groupWidget.entity.description;
        //groupWidget.subTitle = groupWidget.entity.note;
    }

    setupSlotMapping(slotWidget: any) {
        // übersteuern...

        //slotWidget.title = slotWidget.entity.description;
    }

    addGroup(entity: any, id: any, service: any) {

        if (!service) {
            service = entity.ref_vt_service_ev_serv;
        }
        var group = new TimeSlotGroup({
            entity: entity,
            entityId: id,
            service: service
        });

        if (!group.service) {
            console.warn("Timeslotgroup without service!", group);
        }

        this._groups.push(group);

        (group as any).setupMapping = lang.hitch(group, this.setupGroupMapping);
        (group as any).setupSlotMapping = lang.hitch(group, this.setupSlotMapping);
        group.on("selected", lang.hitch(this, "_onSlotSelect"));


        //if (group.entity.ref_vt_service_ev_serv.Classname == "service_ev_room") {
            group.placeAt(this.groupContainerNode);
            //domClass.remove(this.groupContainerNode_h3, "w3-hide");
        //} else {
        //    group.placeAt(this.groupContainerNode_roomGroups);
        //    domClass.remove(this.groupContainerNode_roomGroups_h3, "w3-hide");
        //    domClass.remove(this.groupContainerNode_roomGroups, "w3-hide");
        //}


        group.startup();

        return group;
    }

    getGroup(entity: any) {
        for (var i = 0; i < this._groups.length; i++) {
            var group = this._groups[i];

            if (group.entity == entity) {
                return group;
            }
        }
    }

    getGroupById(entityId: any) {
        for (var i = 0; i < this._groups.length; i++) {
            var group = this._groups[i];

            if (group.entityId == entityId) {
                return group;
            }
        }
    }

    clear() {
        for (var i = 0; i < this._groups.length; i++) {
            var group = this._groups[i];

            group.destroy();
        }

        this._groups = [];
        domConstruct.empty(this.groupContainerNode);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
TimeSlotPicker.prototype.declaredClass = 'more.Controls.TimeSlotPicker.TimeSlotPicker';

export default mdsWidget(TimeSlotPicker);
